import { render, staticRenderFns } from "./sampleTagEdit.vue?vue&type=template&id=a3a4a88a&scoped=true"
import script from "./sampleTagEdit.vue?vue&type=script&lang=js"
export * from "./sampleTagEdit.vue?vue&type=script&lang=js"
import style0 from "./sampleTagEdit.vue?vue&type=style&index=0&id=a3a4a88a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a4a88a",
  null
  
)

export default component.exports